import React, { useState } from "react";
import { View, Text, TextInput, TouchableOpacity, StyleSheet, Image, SafeAreaView, ActivityIndicator } from "react-native";
import { useAuth } from "../context/AuthContext";
import { useNavigate, useLocation } from "react-router-dom";

const TwoFactor = () => {
	const [code, setCode] = useState("");
	const [error, setError] = useState("");
	const [loading, setLoading] = useState(false);
	const { confirmSignUp } = useAuth();
	const navigate = useNavigate();
	const location = useLocation();

	// Get email from location state
	const email = location.state?.email || "";

	if (!email) {
		// Redirect to signup if no email is provided
		navigate("/signup");
	}

	const handleVerify = async () => {
		if (!code) {
			setError("Please enter the verification code");
			return;
		}

		setError("");
		setLoading(true);

		try {
			const success = await confirmSignUp(email, code);
			if (success) {
				navigate("/login", { state: { verified: true } });
			} else {
				setError("Invalid verification code. Please try again.");
			}
		} catch (err) {
			setError(err.message || "An error occurred during verification");
		} finally {
			setLoading(false);
		}
	};

	return (
		<SafeAreaView style={styles.container}>
			<View style={styles.content}>
				{/* Logo */}
				<View style={styles.logoContainer}>
					<View style={styles.logoBox}>
						<Image source={require("../assets/logowhitetrans.png")} style={styles.logo} resizeMode="contain" />
					</View>
				</View>

				{/* Welcome Text */}
				<View style={styles.welcomeContainer}>
					<Text style={styles.welcomeTitle}>Verify your email</Text>
					<Text style={styles.welcomeSubtitle}>We've sent a verification code to {email}</Text>
					{error ? <Text style={styles.errorText}>{error}</Text> : null}
				</View>

				{/* Form */}
				<View style={styles.form}>
					<View style={styles.inputContainer}>
						<Text style={styles.label}>Verification Code</Text>
						<TextInput style={styles.input} placeholder="Enter verification code" placeholderTextColor="#666" value={code} onChangeText={setCode} keyboardType="number-pad" editable={!loading} />
					</View>

					<TouchableOpacity style={[styles.verifyButton, loading && styles.buttonDisabled]} onPress={handleVerify} disabled={loading}>
						{loading ? <ActivityIndicator color="white" /> : <Text style={styles.verifyButtonText}>Verify</Text>}
					</TouchableOpacity>

					<TouchableOpacity onPress={() => navigate("/signup")} disabled={loading}>
						<Text style={styles.backLink}>Back to Sign Up</Text>
					</TouchableOpacity>
				</View>
			</View>
		</SafeAreaView>
	);
};

const styles = StyleSheet.create({
	container: {
		flex: 1,
		backgroundColor: "#000000",
	},
	content: {
		flex: 1,
		padding: 24,
		justifyContent: "center",
		maxWidth: 400,
		alignSelf: "center",
		width: "100%",
	},
	logoContainer: {
		alignItems: "center",
		marginBottom: 32,
	},
	logoBox: {
		width: 200,
		height: 48,
		backgroundColor: "transparent",
		borderRadius: 12,
		justifyContent: "center",
		alignItems: "center",
	},
	logo: {
		width: 180,
		height: 40,
	},
	welcomeContainer: {
		alignItems: "center",
		marginBottom: 32,
	},
	welcomeTitle: {
		fontSize: 24,
		fontWeight: "bold",
		color: "white",
		marginBottom: 8,
	},
	welcomeSubtitle: {
		fontSize: 16,
		color: "#666",
		textAlign: "center",
	},
	form: {
		gap: 16,
	},
	inputContainer: {
		marginBottom: 16,
	},
	label: {
		color: "#666",
		marginBottom: 8,
		fontSize: 14,
	},
	input: {
		backgroundColor: "#1A1A1A",
		borderWidth: 1,
		borderColor: "#333",
		borderRadius: 6,
		padding: 12,
		color: "white",
		fontSize: 14,
	},
	verifyButton: {
		backgroundColor: "#0066FF",
		padding: 16,
		borderRadius: 6,
		alignItems: "center",
		marginBottom: 16,
	},
	verifyButtonText: {
		color: "white",
		fontSize: 14,
		fontWeight: "500",
	},
	backLink: {
		color: "#0066FF",
		fontSize: 14,
		textAlign: "center",
	},
	errorText: {
		color: "#ff4444",
		marginTop: 8,
		fontSize: 14,
		textAlign: "center",
	},
	buttonDisabled: {
		opacity: 0.7,
	},
});

export default TwoFactor;
